import { Spinner } from "@chakra-ui/react";

const BXLoading = () => {
  return (
    <div className="bixin-wallet-pay-loading-style">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </div>
  );
};

export default BXLoading;
